import {createElement} from 'methods/utils';
import ComponentElement from 'components/component-element';
import SplitPayModal from './split-pay-modal';
import splitPayHintIcon from './split-pay-hint-icon';

class SplitPayButton extends ComponentElement {
    constructor($element, options) {
        super($element, { data: {}, ...options });

        this.$element.addEventListener('click', () => {
            SplitPayModal   
                .getInstance()
                .setSplits(this.options.data)
                .open();
        });
    }

    getElement() {
        return this.$element;
    }

    static make(options) {
        const $element = createElement(`
            <button type="button" class="Split-pay-button js-split-pay-button">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.6654 4.66667H11.9987V4C11.9987 3.46957 11.788 2.96086 11.4129 2.58579C11.0378 2.21071 10.5291 2 9.9987 2H3.33203C2.8016 2 2.29289 2.21071 1.91782 2.58579C1.54274 2.96086 1.33203 3.46957 1.33203 4V12C1.33203 12.5304 1.54274 13.0391 1.91782 13.4142C2.29289 13.7893 2.8016 14 3.33203 14H12.6654C13.1958 14 13.7045 13.7893 14.0796 13.4142C14.4546 13.0391 14.6654 12.5304 14.6654 12V6.66667C14.6654 6.13623 14.4546 5.62753 14.0796 5.25245C13.7045 4.87738 13.1958 4.66667 12.6654 4.66667ZM3.33203 3.33333H9.9987C10.1755 3.33333 10.3451 3.40357 10.4701 3.5286C10.5951 3.65362 10.6654 3.82319 10.6654 4V4.66667H3.33203C3.15522 4.66667 2.98565 4.59643 2.86063 4.4714C2.7356 4.34638 2.66536 4.17681 2.66536 4C2.66536 3.82319 2.7356 3.65362 2.86063 3.5286C2.98565 3.40357 3.15522 3.33333 3.33203 3.33333ZM13.332 10H12.6654C12.4886 10 12.319 9.92976 12.194 9.80474C12.0689 9.67971 11.9987 9.51014 11.9987 9.33333C11.9987 9.15652 12.0689 8.98695 12.194 8.86193C12.319 8.73691 12.4886 8.66667 12.6654 8.66667H13.332V10ZM13.332 7.33333H12.6654C12.1349 7.33333 11.6262 7.54405 11.2512 7.91912C10.8761 8.29419 10.6654 8.8029 10.6654 9.33333C10.6654 9.86377 10.8761 10.3725 11.2512 10.7475C11.6262 11.1226 12.1349 11.3333 12.6654 11.3333H13.332V12C13.332 12.1768 13.2618 12.3464 13.1368 12.4714C13.0117 12.5964 12.8422 12.6667 12.6654 12.6667H3.33203C3.15522 12.6667 2.98565 12.5964 2.86063 12.4714C2.7356 12.3464 2.66536 12.1768 2.66536 12V5.88667C2.87954 5.96201 3.10499 6.00034 3.33203 6H12.6654C12.8422 6 13.0117 6.07024 13.1368 6.19526C13.2618 6.32029 13.332 6.48986 13.332 6.66667V7.33333Z" fill="#316BFF"/>
                </svg>
                Плати частями
                ${splitPayHintIcon}
            </button>
        `);

        return new SplitPayButton($element, options);
    }
}

export default SplitPayButton;